// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GcpSpec } from './GcpSpec';
import {
  GcpSpecFromJSON,
  GcpSpecFromJSONTyped,
  GcpSpecToJSON,
  GcpSpecToJSONTyped,
} from './GcpSpec';
import type { AuratypesCloudProvider } from './AuratypesCloudProvider';
import {
  AuratypesCloudProviderFromJSON,
  AuratypesCloudProviderFromJSONTyped,
  AuratypesCloudProviderToJSON,
  AuratypesCloudProviderToJSONTyped,
} from './AuratypesCloudProvider';
import type { V1ClusterRole } from './V1ClusterRole';
import {
  V1ClusterRoleFromJSON,
  V1ClusterRoleFromJSONTyped,
  V1ClusterRoleToJSON,
  V1ClusterRoleToJSONTyped,
} from './V1ClusterRole';
import type { AwsSpec } from './AwsSpec';
import {
  AwsSpecFromJSON,
  AwsSpecFromJSONTyped,
  AwsSpecToJSON,
  AwsSpecToJSONTyped,
} from './AwsSpec';
import type { V1IsolationUnit } from './V1IsolationUnit';
import {
  V1IsolationUnitFromJSON,
  V1IsolationUnitFromJSONTyped,
  V1IsolationUnitToJSON,
  V1IsolationUnitToJSONTyped,
} from './V1IsolationUnit';
import type { AzureSpec } from './AzureSpec';
import {
  AzureSpecFromJSON,
  AzureSpecFromJSONTyped,
  AzureSpecToJSON,
  AzureSpecToJSONTyped,
} from './AzureSpec';

/**
 *
 * @export
 * @interface V1ClusterSpec
 */
export interface V1ClusterSpec {
  /**
   *
   * @type {AwsSpec}
   * @memberof V1ClusterSpec
   */
  aws?: AwsSpec;
  /**
   *
   * @type {AzureSpec}
   * @memberof V1ClusterSpec
   */
  azure?: AzureSpec;
  /**
   *
   * @type {AuratypesCloudProvider}
   * @memberof V1ClusterSpec
   */
  cloudProvider?: AuratypesCloudProvider;
  /**
   *
   * @type {GcpSpec}
   * @memberof V1ClusterSpec
   */
  gcp?: GcpSpec;
  /**
   *
   * @type {V1IsolationUnit}
   * @memberof V1ClusterSpec
   */
  isolationUnit?: V1IsolationUnit;
  /**
   *
   * @type {string}
   * @memberof V1ClusterSpec
   */
  partitionName?: string;
  /**
   *
   * @type {string}
   * @memberof V1ClusterSpec
   */
  region?: string;
  /**
   *
   * @type {Array<V1ClusterRole>}
   * @memberof V1ClusterSpec
   */
  roles?: Array<V1ClusterRole>;
}

/**
 * Check if a given object implements the V1ClusterSpec interface.
 */
export function instanceOfV1ClusterSpec(value: object): value is V1ClusterSpec {
  return true;
}

export function V1ClusterSpecFromJSON(json: any): V1ClusterSpec {
  return V1ClusterSpecFromJSONTyped(json, false);
}

export function V1ClusterSpecFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V1ClusterSpec {
  if (json == null) {
    return json;
  }
  return {
    aws: json['aws'] == null ? undefined : AwsSpecFromJSON(json['aws']),
    azure: json['azure'] == null ? undefined : AzureSpecFromJSON(json['azure']),
    cloudProvider:
      json['cloud_provider'] == null
        ? undefined
        : AuratypesCloudProviderFromJSON(json['cloud_provider']),
    gcp: json['gcp'] == null ? undefined : GcpSpecFromJSON(json['gcp']),
    isolationUnit:
      json['isolation_unit'] == null
        ? undefined
        : V1IsolationUnitFromJSON(json['isolation_unit']),
    partitionName:
      json['partition_name'] == null ? undefined : json['partition_name'],
    region: json['region'] == null ? undefined : json['region'],
    roles:
      json['roles'] == null
        ? undefined
        : (json['roles'] as Array<any>).map(V1ClusterRoleFromJSON),
  };
}

export function V1ClusterSpecToJSON(json: any): V1ClusterSpec {
  return V1ClusterSpecToJSONTyped(json, false);
}

export function V1ClusterSpecToJSONTyped(
  value?: V1ClusterSpec | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    aws: AwsSpecToJSON(value['aws']),
    azure: AzureSpecToJSON(value['azure']),
    cloud_provider: AuratypesCloudProviderToJSON(value['cloudProvider']),
    gcp: GcpSpecToJSON(value['gcp']),
    isolation_unit: V1IsolationUnitToJSON(value['isolationUnit']),
    partition_name: value['partitionName'],
    region: value['region'],
    roles:
      value['roles'] == null
        ? undefined
        : (value['roles'] as Array<any>).map(V1ClusterRoleToJSON),
  };
}
